<template>
    <el-tooltip>
        <div>
            <span>{{ organizer.name }}</span>
            <font-awesome-icon
                v-if="organizer.address || organizer.mail || organizer.phone"
                class="ml-1"
                icon="info-circle" />
        </div>
        <template #content>
            <div class="text-white d-flex flex-column gap-2">
                <h4 class="text-white">
                    {{ organizer.name }}
                </h4>
                <div
                    v-if="organizerAddress"
                    class="d-flex gap-2 align-items-center">
                    <font-awesome-icon
                        icon="map-marker-alt"
                        fixed-width />
                    <span style="white-space: pre-line">{{ organizerAddress }}</span>
                </div>
                <div
                    v-if="organizer.mail"
                    class="d-flex gap-2 align-items-center">
                    <font-awesome-icon
                        icon="at"
                        fixed-width />
                    <span>
                        {{ organizer.mail }}
                    </span>
                </div>
                <div
                    v-if="organizer.phone"
                    class="d-flex gap-2 align-items-center">
                    <font-awesome-icon
                        icon="phone"
                        fixed-width />
                    <span>
                        {{ organizer.phone }}
                    </span>
                </div>
            </div>
        </template>
    </el-tooltip>
</template>

<script>
export default {
    name: "OrganizerTooltip",
    props: {
        organizer: {
            type: Object,
            required: true
        }
    },
    computed: {
        organizerAddress() {
            if (this.organizer?.address?.addressAsString) return this.organizer?.address?.addressAsString
            else if (typeof this.organizer?.address === "string") return this.organizer?.address?.replace(',', '\n')
            else return null
        }
    }
}
</script>

<style scoped>

</style>